import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { ResourceStateCellRenderer } from "../column-def-cell-renderers/unused-since/ResourceStateCellRenderer";
import {
  FilteredAzAksVmResourceItem,
  UnusedSince,
} from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azAksVmColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_aks_vm"),

  {
    field: "resource.resource_state",
    headerName: "State",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredAzAksVmResourceItem>) => {
      if (!data) {
        return null;
      }

      const unusedSince = data?.resource?.unused_since as UnusedSince;

      return (
        <ResourceStateCellRenderer
          state={data?.resource?.resource_state}
          unusedSince={unusedSince}
        />
      );
    },
  },

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "az_aks_vm"),

  resourceTotalSpendColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.type", headerName: "Machine Size" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
